export default __webpack_public_path__ + "static/media/multifunctionmeter.80875611.webp";